import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OpenKeyEncryptionSidebarService {
  private subject = new Subject<void | any>();

  // Sends a message, can be used to notify components about changes.
  sendMessage(message: any) {
    this.subject.next(message);
  }

  // Clears all messages, typically used for resetting or clearing state.
  clearMessages() {
    this.subject.next(null);
  }

  // Returns an observable that components can subscribe to for real-time updates.
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
